import { Text } from '@wyz/ui';
import { Trans } from '~/common/context';
import { TranslationKeys } from '~/common/types';
import { USER_STATUSES } from '~/connect/schemas';
import { IUser } from '~/connect/types';

interface Props {
  user: IUser;
}

const LABELS: Record<keyof typeof USER_STATUSES, keyof TranslationKeys> = {
  [USER_STATUSES.ENABLED]: 'app.common.status.enabled',
  [USER_STATUSES.DISABLED]: 'app.common.status.disabled',
} as const;

const VARIANT = {
  [USER_STATUSES.ENABLED]: 'success',
  [USER_STATUSES.DISABLED]: 'danger',
} as const;

export const UserStatusCell = ({ user }: Props) => {
  return (
    <Text color={VARIANT[user.status]} weight='bold' heading='xxs'>
      <Trans i18nKey={LABELS[user.status]} />
    </Text>
  );
};
